export default __webpack_public_path__ + "static/media/selena.e4567648.jpg";